<template>
  <div class="page-wrapper">
    <img v-if="imageUrl" class="members-image" :src="imageUrl" alt="" />
  </div>
</template>

<script>
import { getData } from '@/request/api/model'

const CATEGORY_ID = '1985184818377871362'

export default {
  data() {
    return {
      language: localStorage.getItem('Language'),
      imageUrl: ''
    }
  },
  created() {
    this.getMembersImage()
  },
  methods: {
    async getMembersImage() {
      try {
        const res = await getData({
          categoryId: CATEGORY_ID,
          contentType: this.language === 'zh-CN' ? '0,1' : '0,2',
          publishChannel: '0,2'
        })

        if (!res || res.code !== 0 || !Array.isArray(res.data)) {
          return
        }

        const imageItem = res.data[0]

        if (imageItem) {
          this.imageUrl = imageItem.contentFileList.find((url) => {
            return typeof url === 'string' && url.trim()
          })
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.page-wrapper {
  height: 100%;
  width: 100%;
  .members-image {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
